import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { PanelDashboardModel } from '@/libs/Api';
import { PanelDashboardsDataService } from '@/libs/panel-dashboards/panel-dashboards-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const panelDashboardsStore = registerCrudStore<PanelDashboardModel, PanelDashboardModel>(
    BusinessModule.PanelDashboard,
    new PanelDashboardsDataService()
);
